export default function sketch(p) {

    let visualization_data;  //[["1,1,1"] 2,2,2;3,3,3..."],[frame_length,["1,1,1;2,2,2;3,3,3..."]]
    let call_click_function_above;
    let canvas_dimension = 354; 
    let inter_pixel_padding = 2; 
    let pixel_size = 40

    p.setup = () => {
        
        p.createCanvas(canvas_dimension, canvas_dimension)
        p.noStroke()
        p.background('#343434')

        p.textSize(18)
        p.fill(0)
        let row_nr_startx = 34
        let row_nr_starty = 15
        //column numbers
        for (let nr = 0; nr < 8; nr++) {
            p.text(nr.toString(), row_nr_startx,row_nr_starty)
            row_nr_startx = row_nr_startx + pixel_size + inter_pixel_padding
        }
        // //row numbers
        let col_nr_startx = 5
        let col_nr_starty = 44
        for (let nr = 0; nr < 8; nr++) {
            p.text(nr.toString(),col_nr_startx, col_nr_starty)
            col_nr_starty = col_nr_starty + pixel_size + inter_pixel_padding
        }

        
        
    }

    p.draw = () => {

        
        let x = 20
        let y = 20

        
        let item = 0

        for (let row = 0; row < 8; row++) {
            for (let col = 0; col < 8; col++) {

                let r = visualization_data[item][0]
                let g = visualization_data[item][1]
                let b = visualization_data[item][2]

                p.fill(r,g,b)

                p.rect(x, y, pixel_size, pixel_size, 3)
                x = x + pixel_size + inter_pixel_padding
                item = item + 1
            }
            y = y + pixel_size + inter_pixel_padding
            x = 20
        }


    }



    p.myCustomRedrawAccordingToNewPropsHandler = (props) => {
        
        //reset
        visualization_data = []
        call_click_function_above = props.mouseClick
       
        //reading the received json into data visualization in the correct format 
        visualization_data = props.data

    }

  

    p.mousePressed = () =>{

        if (p.mouseX <= canvas_dimension && p.mouseX >=0 && p.mouseY <= canvas_dimension && p.mouseY >=0){
            let col = parseInt((p.mouseX-20)/(pixel_size+inter_pixel_padding/2)) 
            let row = parseInt((p.mouseY-20)/(pixel_size+inter_pixel_padding/2)) 
           
            return call_click_function_above(row,col)
        }
        
    }




}

